import dynamic from 'next/dynamic';
import publicRoutes from '@/public-routes.json';
import Header from '@/components/header/Header';
import Footer from '@/components/footer/Footer';
import AllHomeConfig from '@/features/allHome/json/config.json';
import LAHIPConfig from '@/features/lahip/json/config.json';
import FamilyResourceFinderConfig from '@/features/familyresourcefinder/json/config.json';
import familyResourceFinderT from '@/features/familyresourcefinder/utils/Language/familyResourceFinder-translations';

const AllHomeHeader = dynamic(() => import('@/features/allHome/components/Header/Header'), { ssr: false });
const AllHomeFooter = dynamic(() => import('@/features/allHome/components/Footer/Footer'), { ssr: false });
const LAHIPHeader = dynamic(() => import('@/features/lahip/components/Header/Header'), { ssr: false });
const LAHIPFooter = dynamic(() => import('@/features/lahip/components/Footer/Footer'), { ssr: false });
const FamilyResourceFinderHeader = dynamic(() => import('@/features/portal/components/Header/Header'), { ssr: false });
const FamilyResourceFinderFooter = dynamic(() => import('@/features/familyresourcefinder/components/Footer/Footer'), {
  ssr: false
});

const themeHelpers = {
  getTheme: (router) => {
    if (router.query.theme) {
      return router.query.theme;
    }
    let theme;
    const pageRoot = router.asPath.split(/[?#]/)[0].split('/')[1]; // strip query params and hash fragments with the first split, then get the primary URL path like `stayhousedbayarea` with the second
    if (pageRoot == publicRoutes.lacountyassist) {
      theme = 'lahip';
    } else if (pageRoot == publicRoutes.allhome) {
      theme = 'allhome';
    } else if (pageRoot == publicRoutes.familyresourcefinder) {
      theme = 'familyresourcefinder';
    } else {
      theme = 'prime';
    }
    return theme;
  },
  getHomePath: (theme) => {
    switch (theme) {
      case 'lahip':
        return `/${publicRoutes.lacountyassist}`;
      case 'allhome':
        return `/${publicRoutes.allhome}`;
      case 'familyresourcefinder':
        return `/${publicRoutes.familyresourcefinder}`;
      default:
        return '/';
    }
  },
  renderHeader: (theme, changeLanguage) => {
    switch (theme?.toLowerCase()) {
      case 'allhome':
        return <AllHomeHeader config={AllHomeConfig} changeLanguage={changeLanguage} />;
      case 'lahip':
        return <LAHIPHeader config={LAHIPConfig.config} changeLanguage={changeLanguage} />;
      case 'familyresourcefinder':
        return <FamilyResourceFinderHeader config={FamilyResourceFinderConfig} t={familyResourceFinderT} changeLanguage={changeLanguage} />;
      default:
        return <Header />;
    }
  },
  renderFooter: (theme, changeLanguage) => {
    switch (theme?.toLowerCase()) {
      case 'allhome':
        return <AllHomeFooter config={AllHomeConfig} changeLanguage={changeLanguage} />;
      case 'lahip':
        return <LAHIPFooter config={LAHIPConfig.config} changeLanguage={changeLanguage} />;
      case 'familyresourcefinder':
        return <FamilyResourceFinderFooter config={FamilyResourceFinderConfig} changeLanguage={changeLanguage} />;
      default:
        return <Footer />;
    }
  }
};

export default themeHelpers;
